<template>
  <ViewWrapper headingText="Users">
    <Users></Users>
  </ViewWrapper>
</template>

<script>
import ViewWrapper from '@/components/ViewWrapper'
import Users from '@/components/manage/Users'

export default {
  components: { ViewWrapper, Users }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/UsersPage.vue